<template>
	<div class="command-bar-dispaly-svg">
		<svg xmlns="http://www.w3.org/2000/svg" width="480" height="288" viewBox="0 0 480 288">
			<g id="Group_45849" data-name="Group 45849" transform="translate(-721 -519)">
				<g id="Group_45676" data-name="Group 45676" transform="translate(0 -29)">
					<g id="Group_45671" data-name="Group 45671" transform="translate(721 548)">
						<g id="Group_44988" data-name="Group 44988">
							<g id="Group_44984" data-name="Group 44984" transform="translate(0)">
								<g id="Rectangle_15055" data-name="Rectangle 15055" fill="#fff" stroke="#d6ddea" stroke-width="1">
									<rect width="480" height="288" rx="9" stroke="none" />
									<rect x="0.5" y="0.5" width="479" height="287" rx="8.5" fill="none" />
								</g>
								<g id="Rectangle_15068" data-name="Rectangle 15068" fill="none" stroke="#d6ddea" stroke-width="1">
									<path d="M9,0H471a9,9,0,0,1,9,9V33a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z" stroke="none" />
									<path d="M9,.5H471A8.5,8.5,0,0,1,479.5,9V32.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V9A8.5,8.5,0,0,1,9,.5Z" fill="none" />
								</g>
								<line
									id="Line_1370"
									data-name="Line 1370"
									x2="479.5"
									transform="translate(0 32.5)"
									fill="none"
									stroke="#d6ddea"
									stroke-width="1"
								/>
								<g id="Group_44853" data-name="Group 44853" transform="translate(8.402 32.283)">
									<g id="Group_40452" data-name="Group 40452" transform="translate(2 11.567)">
										<rect
											id="Rectangle_12949"
											data-name="Rectangle 12949"
											width="10.809"
											height="1.907"
											rx="0.954"
											fill="rgba(247,247,247,0.1)"
										/>
										<rect
											id="Rectangle_12950"
											data-name="Rectangle 12950"
											width="10.809"
											height="1.907"
											rx="0.954"
											transform="translate(0 3.179)"
											fill="rgba(247,247,247,0.1)"
										/>
										<rect
											id="Rectangle_12951"
											data-name="Rectangle 12951"
											width="10.809"
											height="1.907"
											rx="0.954"
											transform="translate(0 6.358)"
											fill="rgba(247,247,247,0.1)"
										/>
									</g>
									<line
										id="Line_1257"
										data-name="Line 1257"
										x2="450.977"
										transform="translate(20.121 37.217)"
										fill="none"
										stroke="#d6ddea"
										stroke-width="1"
									/>
									<g id="Group_44954" data-name="Group 44954" transform="translate(432.949 12.716)">
										<path
											id="Path_29013"
											data-name="Path 29013"
											d="M5.351,6.7A1.351,1.351,0,1,0,4,5.351,1.355,1.355,0,0,0,5.351,6.7ZM9.4,14.809a1.351,1.351,0,1,0-1.351-1.351A1.355,1.355,0,0,0,9.4,14.809Zm-4.053,0A1.351,1.351,0,1,0,4,13.458,1.355,1.355,0,0,0,5.351,14.809Zm0-4.053A1.351,1.351,0,1,0,4,9.4,1.355,1.355,0,0,0,5.351,10.756Zm4.053,0A1.351,1.351,0,1,0,8.053,9.4,1.355,1.355,0,0,0,9.4,10.756Zm2.7-5.4A1.351,1.351,0,1,0,13.458,4,1.355,1.355,0,0,0,12.107,5.351ZM9.4,6.7A1.351,1.351,0,1,0,8.053,5.351,1.355,1.355,0,0,0,9.4,6.7Zm4.053,4.053A1.351,1.351,0,1,0,12.107,9.4,1.355,1.355,0,0,0,13.458,10.756Zm0,4.053a1.351,1.351,0,1,0-1.351-1.351A1.355,1.355,0,0,0,13.458,14.809Z"
											transform="translate(15.71 -4)"
											fill="#d6ddea"
										/>
										<g id="Group_40451" data-name="Group 40451">
											<path
												id="Path_29014"
												data-name="Path 29014"
												d="M8.4,12.569h-2a.778.778,0,0,1-.783-.67l-.146-1a4.895,4.895,0,0,1-.427-.243l-.973.38A.806.806,0,0,1,3.1,10.7L2.107,9.024A.769.769,0,0,1,2.3,8.032L3.129,7.4c-.005-.079-.011-.158-.011-.243s.005-.164.011-.243l-.821-.628a.747.747,0,0,1-.2-.992l1-1.683a.786.786,0,0,1,.967-.332l.978.385c.14-.09.281-.169.421-.243l.146-1.008A.781.781,0,0,1,6.4,1.76h2a.778.778,0,0,1,.783.67l.146,1a4.894,4.894,0,0,1,.427.243l.973-.38a.811.811,0,0,1,.983.343L12.7,5.31a.763.763,0,0,1-.195.992l-.821.628c.005.079.011.158.011.243s-.005.164-.011.243l.821.628a.761.761,0,0,1,.2.981l-1,1.7a.791.791,0,0,1-.973.332l-.973-.38c-.14.09-.281.169-.421.243l-.146,1.008a.788.788,0,0,1-.789.644ZM6.657,11.514H8.148l.2-1.345.286-.116a3.4,3.4,0,0,0,.724-.411L9.6,9.462l1.286.506L11.633,8.7l-1.1-.833.038-.3a3.43,3.43,0,0,0,.032-.411,3.345,3.345,0,0,0-.032-.411l-.038-.3,1.1-.833-.751-1.266L9.59,4.862l-.243-.185a3.242,3.242,0,0,0-.719-.406l-.281-.116-.2-1.345H6.657l-.2,1.345-.286.111a3.438,3.438,0,0,0-.724.417L5.2,4.856l-1.286-.5L3.166,5.616l1.1.833-.038.3a3.607,3.607,0,0,0-.032.417,2.59,2.59,0,0,0,.032.411l.038.3-1.1.833.746,1.266L5.2,9.462l.243.185a3.044,3.044,0,0,0,.719.406l.286.116.205,1.345Z"
												transform="translate(-1.999 -1.76)"
												fill="#d6ddea"
											/>
											<ellipse
												id="Ellipse_734"
												data-name="Ellipse 734"
												cx="1.709"
												cy="1.709"
												rx="1.709"
												ry="1.709"
												transform="translate(3.694 3.692)"
												fill="#d6ddea"
											/>
										</g>
									</g>
									<line
										id="Line_1258"
										data-name="Line 1258"
										y2="186.229"
										transform="translate(99.977 68.244)"
										fill="none"
										stroke="#d6ddea"
										stroke-width="1"
									/>
									<line
										id="Line_1371"
										data-name="Line 1371"
										y2="254.473"
										transform="translate(20.121)"
										fill="none"
										stroke="#d6ddea"
										stroke-width="1"
									/>
									<g id="Group_44852" data-name="Group 44852" transform="translate(0 10.597)">
										<rect id="Rectangle_15056" data-name="Rectangle 15056" width="10.809" height="10.809" rx="4" fill="#f4f6f9" />
										<rect
											id="Rectangle_15057"
											data-name="Rectangle 15057"
											width="10.809"
											height="10.809"
											rx="4"
											transform="translate(0 17.574)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15058"
											data-name="Rectangle 15058"
											width="10.809"
											height="10.809"
											rx="4"
											transform="translate(0 36.142)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15059"
											data-name="Rectangle 15059"
											width="52.773"
											height="6.994"
											rx="3.497"
											transform="translate(105.598 61.691)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15060"
											data-name="Rectangle 15060"
											width="30.519"
											height="6.994"
											rx="3.497"
											transform="translate(105.493 102.383)"
											fill="#f4f6f9"
										/>
										<g id="Group_44850" data-name="Group 44850" transform="translate(105.493 75.043)">
											<rect
												id="Rectangle_12938"
												data-name="Rectangle 12938"
												width="38.149"
												height="6.994"
												rx="3.497"
												transform="translate(0 0)"
												fill="#f4f6f9"
											/>
											<rect
												id="Rectangle_12939"
												data-name="Rectangle 12939"
												width="38.149"
												height="6.994"
												rx="3.497"
												transform="translate(41.372 0)"
												fill="#f4f6f9"
											/>
											<rect
												id="Rectangle_12940"
												data-name="Rectangle 12940"
												width="80.749"
												height="6.994"
												rx="3.497"
												transform="translate(81.422 0)"
												fill="#f4f6f9"
											/>
										</g>
										<g id="Group_44851" data-name="Group 44851" transform="translate(105.493 89.031)">
											<rect
												id="Rectangle_12942"
												data-name="Rectangle 12942"
												width="38.149"
												height="6.994"
												rx="3.497"
												transform="translate(82.573 0)"
												fill="#f4f6f9"
											/>
											<rect
												id="Rectangle_12941"
												data-name="Rectangle 12941"
												width="80.749"
												height="6.994"
												rx="3.497"
												transform="translate(0 0)"
												fill="#f4f6f9"
											/>
										</g>
										<rect
											id="Rectangle_15062"
											data-name="Rectangle 15062"
											width="52.773"
											height="6.994"
											rx="3.497"
											transform="translate(28.3 46.952)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15063"
											data-name="Rectangle 15063"
											width="38.149"
											height="6.994"
											rx="3.497"
											transform="translate(28.3 60.573)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15064"
											data-name="Rectangle 15064"
											width="38.149"
											height="6.994"
											rx="3.497"
											transform="translate(28.3 93.248)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15065"
											data-name="Rectangle 15065"
											width="22.254"
											height="6.994"
											rx="3.497"
											transform="translate(28.3 79.626)"
											fill="#f4f6f9"
										/>
										<rect
											id="Rectangle_15066"
											data-name="Rectangle 15066"
											width="29.248"
											height="6.994"
											rx="3.497"
											transform="translate(51.825 79.626)"
											fill="#f4f6f9"
										/>
										<g id="Group_44986" data-name="Group 44986" transform="translate(105.598 39.625)">
											<circle id="Ellipse_866" data-name="Ellipse 866" cx="9.327" cy="9.327" r="9.327" fill="#f4f6f9" />
											<path
												id="Path_30262"
												data-name="Path 30262"
												d="M14.767,23.14H11.312a4.385,4.385,0,0,0-4.385,4.385v.653a9.295,9.295,0,0,0,12.224,0v-.653a4.385,4.385,0,0,0-4.385-4.385"
												transform="translate(-3.713 -12.066)"
												fill="#d6ddea"
											/>
											<path
												id="Path_30263"
												data-name="Path 30263"
												d="M18.9,9.331a3.629,3.629,0,1,0-3.629,3.629A3.629,3.629,0,0,0,18.9,9.331"
												transform="translate(-6.067 -3.352)"
												fill="#d6ddea"
											/>
										</g>
									</g>
								</g>
								<g id="Group_44985" data-name="Group 44985" transform="translate(11.349 10.965)">
									<rect
										id="Rectangle_11441"
										data-name="Rectangle 11441"
										width="275.111"
										height="11.255"
										rx="5"
										transform="translate(67.65 0)"
										fill="#d6dde9"
										opacity="0.526"
									/>
									<g id="Group_37615" data-name="Group 37615" transform="translate(0 1.92)">
										<circle id="Ellipse_677" data-name="Ellipse 677" cx="3.664" cy="3.664" r="3.664" fill="#d6dde9" />
										<circle
											id="Ellipse_678"
											data-name="Ellipse 678"
											cx="3.664"
											cy="3.664"
											r="3.664"
											transform="translate(10.792)"
											fill="#d6dde9"
										/>
										<circle
											id="Ellipse_679"
											data-name="Ellipse 679"
											cx="3.664"
											cy="3.664"
											r="3.664"
											transform="translate(21.584)"
											fill="#d6dde9"
										/>
									</g>
								</g>
							</g>
						</g>
						<g
							id="Rectangle_15116"
							data-name="Rectangle 15116"
							transform="translate(0 32)"
							fill="rgba(128,137,156,0.7)"
							stroke="#d6ddea"
							stroke-width="1"
							opacity="0.468"
						>
							<path d="M0,0H480a0,0,0,0,1,0,0V247a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9V0A0,0,0,0,1,0,0Z" stroke="none" />
							<path d="M.5.5h479a0,0,0,0,1,0,0V247a8.5,8.5,0,0,1-8.5,8.5H9A8.5,8.5,0,0,1,.5,247V.5A0,0,0,0,1,.5.5Z" fill="none" />
						</g>
					</g>
					<g id="Group_45673" data-name="Group 45673" transform="translate(774.109 648.998)">
						<g id="Group_45672" data-name="Group 45672">
							<path
								id="Path_30445"
								data-name="Path 30445"
								d="M8.523,0H385.8c4.707,0,8.523,2.416,8.523,5.4V134.553c0,2.98-3.816,5.4-8.523,5.4H8.523c-4.707,0-8.523-2.416-8.523-5.4V5.4C0,2.416,3.816,0,8.523,0"
								fill="#fff"
								stroke="#eef0f4"
								stroke-width="1"
							/>
							<rect
								id="Rectangle_15105"
								data-name="Rectangle 15105"
								width="374.156"
								height="0.571"
								transform="translate(10.892 104.481)"
								fill="#f2f4f7"
							/>
							<path
								id="Path_30446"
								data-name="Path 30446"
								d="M81.288,361.63H79.48V361h4.334v.634H82v5.08h-.711Z"
								transform="translate(-34.092 -242.066)"
								fill="#737376"
							/>
							<path
								id="Path_30447"
								data-name="Path 30447"
								d="M86.53,365.743a2.051,2.051,0,1,1,2.047,2.176,2.03,2.03,0,0,1-2.047-2.176m3.418,0a1.391,1.391,0,1,0-1.371,1.6,1.438,1.438,0,0,0,1.371-1.6"
								transform="translate(-37.115 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30448"
								data-name="Path 30448"
								d="M102.193,365.109c0-.728-.368-.959-.925-.959a1.6,1.6,0,0,0-1.225.642v3.024H99.4v-4.137h.642v.6a2.051,2.051,0,0,1,1.473-.7,1.176,1.176,0,0,1,1.319,1.336v2.9h-.642Z"
								transform="translate(-42.636 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30449"
								data-name="Path 30449"
								d="M110.077,367.344a1.79,1.79,0,0,1-1.371.574,1.377,1.377,0,0,1-1.448-1.37,1.355,1.355,0,0,1,1.448-1.362,1.729,1.729,0,0,1,1.371.565v-.745c0-.557-.445-.874-1.045-.874a1.644,1.644,0,0,0-1.268.574l-.3-.445a2.164,2.164,0,0,1,1.653-.685c.874,0,1.6.394,1.6,1.4v2.844h-.642Zm0-1.182a1.384,1.384,0,0,0-1.139-.514.91.91,0,1,0,0,1.807,1.384,1.384,0,0,0,1.139-.515Z"
								transform="translate(-46.007 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30450"
								data-name="Path 30450"
								d="M114.49,363.756h.694l1.379,3.392,1.371-3.392h.7l-1.722,4.137h-.7Z"
								transform="translate(-49.108 -243.249)"
								fill="#737376"
							/>
							<path
								id="Path_30451"
								data-name="Path 30451"
								d="M122.725,361.454a.432.432,0,0,1,.865,0,.432.432,0,1,1-.865,0m.111,1.131h.642v4.137h-.642Z"
								transform="translate(-52.641 -242.08)"
								fill="#737376"
							/>
							<path
								id="Path_30452"
								data-name="Path 30452"
								d="M126.431,368.4a1.58,1.58,0,0,0,1.345.565,1.185,1.185,0,0,0,1.328-1.242v-.591a1.728,1.728,0,0,1-1.388.737,1.884,1.884,0,0,1-1.842-2.142c0-1.327.754-2.15,1.842-2.15a1.715,1.715,0,0,1,1.388.729v-.626h.642V367.7c0,1.37-.959,1.8-1.97,1.8a2.114,2.114,0,0,1-1.67-.616Zm2.673-3.581a1.524,1.524,0,0,0-1.234-.668c-.831,0-1.328.66-1.328,1.576s.5,1.576,1.328,1.576a1.531,1.531,0,0,0,1.234-.677Z"
								transform="translate(-53.991 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30453"
								data-name="Path 30453"
								d="M137.317,367.344a1.79,1.79,0,0,1-1.371.574,1.377,1.377,0,0,1-1.448-1.37,1.355,1.355,0,0,1,1.448-1.362,1.729,1.729,0,0,1,1.371.565v-.745c0-.557-.445-.874-1.045-.874a1.644,1.644,0,0,0-1.268.574l-.3-.445a2.164,2.164,0,0,1,1.653-.685c.874,0,1.6.394,1.6,1.4v2.844h-.642Zm0-1.182a1.384,1.384,0,0,0-1.139-.514.91.91,0,1,0,0,1.807,1.384,1.384,0,0,0,1.139-.515Z"
								transform="translate(-58.082 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30454"
								data-name="Path 30454"
								d="M142.519,366.179v-2.707h-.685v-.565h.685v-1.131h.642v1.131H144v.565h-.839v2.57c0,.308.137.53.42.53a.62.62,0,0,0,.437-.171l.188.479a1.048,1.048,0,0,1-.771.266.846.846,0,0,1-.917-.967"
								transform="translate(-61.248 -242.4)"
								fill="#737376"
							/>
							<path
								id="Path_30455"
								data-name="Path 30455"
								d="M148.838,363.576a2.009,2.009,0,0,1,1.987,2.219v.163h-3.349a1.458,1.458,0,0,0,1.49,1.431,1.809,1.809,0,0,0,1.276-.523l.308.42a2.248,2.248,0,0,1-1.645.634,2.174,2.174,0,0,1-.069-4.343m-1.362,1.91h2.715a1.34,1.34,0,0,0-1.361-1.379,1.381,1.381,0,0,0-1.353,1.379"
								transform="translate(-63.394 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30456"
								data-name="Path 30456"
								d="M27.85,366.849H20.426A3.426,3.426,0,0,1,17,363.422v-7.995A3.426,3.426,0,0,1,20.426,352H27.85a3.426,3.426,0,0,1,3.426,3.426v7.995a3.426,3.426,0,0,1-3.426,3.426"
								transform="translate(-7.292 -238.209)"
								fill="#fff"
							/>
							<path
								id="Path_30457"
								data-name="Path 30457"
								d="M27.85,366.849H20.426A3.43,3.43,0,0,1,17,363.422v-7.995A3.43,3.43,0,0,1,20.426,352H27.85a3.43,3.43,0,0,1,3.426,3.426v7.995a3.43,3.43,0,0,1-3.426,3.426m-7.424-14.277a2.859,2.859,0,0,0-2.855,2.855v7.995a2.859,2.859,0,0,0,2.855,2.855H27.85a2.859,2.859,0,0,0,2.855-2.855v-7.995a2.859,2.859,0,0,0-2.855-2.855Z"
								transform="translate(-7.292 -238.209)"
								fill="#e8e8e8"
							/>
							<path
								id="Path_30458"
								data-name="Path 30458"
								d="M30.574,365.291,30,364.663l-.851.926V361.9h-.883v3.686l-.857-.929-.556.628,1.854,1.579Z"
								transform="translate(-11.519 -242.455)"
								fill="#737376"
							/>
							<path
								id="Path_30459"
								data-name="Path 30459"
								d="M50.427,352h7.424a3.426,3.426,0,0,1,3.426,3.426v7.995a3.426,3.426,0,0,1-3.426,3.426H50.427A3.426,3.426,0,0,1,47,363.422v-7.995A3.426,3.426,0,0,1,50.427,352"
								transform="translate(-20.16 -238.209)"
								fill="#fff"
							/>
							<path
								id="Path_30460"
								data-name="Path 30460"
								d="M57.851,366.849H50.427A3.43,3.43,0,0,1,47,363.422v-7.995A3.43,3.43,0,0,1,50.427,352h7.424a3.43,3.43,0,0,1,3.426,3.426v7.995a3.43,3.43,0,0,1-3.426,3.426m-7.424-14.277a2.859,2.859,0,0,0-2.855,2.855v7.995a2.859,2.859,0,0,0,2.855,2.855h7.424a2.859,2.859,0,0,0,2.855-2.855v-7.995a2.859,2.859,0,0,0-2.855-2.855Z"
								transform="translate(-20.16 -238.209)"
								fill="#e8e8e8"
							/>
							<path
								id="Path_30461"
								data-name="Path 30461"
								d="M56.612,363.479l.571.628.851-.926v3.686h.883v-3.686l.857.929.556-.628L58.475,361.9Z"
								transform="translate(-24.283 -242.455)"
								fill="#737376"
							/>
							<path
								id="Path_30462"
								data-name="Path 30462"
								d="M220.287,361.63h-1.807V361h4.334v.634H221v5.08h-.711Z"
								transform="translate(-94.349 -242.066)"
								fill="#737376"
							/>
							<path
								id="Path_30463"
								data-name="Path 30463"
								d="M225.529,365.743a2.051,2.051,0,1,1,2.047,2.176,2.03,2.03,0,0,1-2.047-2.176m3.418,0a1.391,1.391,0,1,0-1.371,1.6,1.438,1.438,0,0,0,1.371-1.6"
								transform="translate(-97.393 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30464"
								data-name="Path 30464"
								d="M238.1,366.805a1.874,1.874,0,0,0,1.362.59c.634,0,.977-.282.977-.685,0-.454-.505-.6-1.062-.737-.7-.163-1.5-.351-1.5-1.208,0-.642.557-1.191,1.542-1.191a2.094,2.094,0,0,1,1.533.6l-.3.445a1.61,1.61,0,0,0-1.233-.523c-.565,0-.917.257-.917.625,0,.4.471.532,1.011.66.72.163,1.55.368,1.55,1.285,0,.694-.556,1.25-1.627,1.25a2.2,2.2,0,0,1-1.67-.65Z"
								transform="translate(-102.678 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30465"
								data-name="Path 30465"
								d="M246.993,363.576a2.009,2.009,0,0,1,1.987,2.219v.163h-3.349a1.458,1.458,0,0,0,1.491,1.431,1.809,1.809,0,0,0,1.276-.523l.308.42a2.248,2.248,0,0,1-1.645.634,2.174,2.174,0,0,1-.069-4.343m-1.362,1.91h2.715a1.34,1.34,0,0,0-1.361-1.379,1.381,1.381,0,0,0-1.353,1.379"
								transform="translate(-105.782 -243.173)"
								fill="#737376"
							/>
							<rect
								id="Rectangle_15106"
								data-name="Rectangle 15106"
								width="0.642"
								height="5.714"
								transform="translate(144.216 118.93)"
								fill="#737376"
							/>
							<path
								id="Path_30466"
								data-name="Path 30466"
								d="M258.812,363.576a2.009,2.009,0,0,1,1.987,2.219v.163H257.45a1.458,1.458,0,0,0,1.49,1.431,1.81,1.81,0,0,0,1.276-.523l.309.42a2.249,2.249,0,0,1-1.645.634,2.174,2.174,0,0,1-.069-4.343m-1.363,1.91h2.715a1.34,1.34,0,0,0-1.361-1.379,1.381,1.381,0,0,0-1.353,1.379"
								transform="translate(-110.885 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30467"
								data-name="Path 30467"
								d="M267.282,363.576a1.771,1.771,0,0,1,1.516.72l-.428.394a1.227,1.227,0,0,0-1.054-.54,1.607,1.607,0,0,0,0,3.2,1.248,1.248,0,0,0,1.054-.54l.428.394a1.772,1.772,0,0,1-1.516.719,2.174,2.174,0,0,1,0-4.342"
								transform="translate(-114.532 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30468"
								data-name="Path 30468"
								d="M272.774,366.179v-2.707h-.685v-.565h.685v-1.131h.642v1.131h.839v.565h-.839v2.57c0,.308.137.53.42.53a.62.62,0,0,0,.437-.171l.188.479a1.047,1.047,0,0,1-.771.266.846.846,0,0,1-.917-.967"
								transform="translate(-117.496 -242.4)"
								fill="#737376"
							/>
							<path
								id="Path_30469"
								data-name="Path 30469"
								d="M192.56,366.849H179.425A3.426,3.426,0,0,1,176,363.422v-7.995A3.426,3.426,0,0,1,179.425,352H192.56a3.426,3.426,0,0,1,3.426,3.426v7.995a3.426,3.426,0,0,1-3.426,3.426"
								transform="translate(-76.026 -238.209)"
								fill="#fff"
							/>
							<path
								id="Path_30470"
								data-name="Path 30470"
								d="M192.56,366.849H179.425A3.43,3.43,0,0,1,176,363.422v-7.995A3.43,3.43,0,0,1,179.425,352H192.56a3.43,3.43,0,0,1,3.426,3.426v7.995a3.43,3.43,0,0,1-3.426,3.426m-13.135-14.277a2.859,2.859,0,0,0-2.855,2.855v7.995a2.859,2.859,0,0,0,2.855,2.855H192.56a2.859,2.859,0,0,0,2.855-2.855v-7.995a2.859,2.859,0,0,0-2.855-2.855Z"
								transform="translate(-76.026 -238.209)"
								fill="#e8e8e8"
							/>
							<path
								id="Path_30471"
								data-name="Path 30471"
								d="M186.215,364.806l1.962-1.963v1.6h3.171a1.264,1.264,0,1,0,0-2.527h-.7v-.723h.7a1.986,1.986,0,1,1,0,3.973h-3.171v1.6Z"
								transform="translate(-80.42 -242.151)"
								fill="#737376"
							/>
							<path
								id="Path_30472"
								data-name="Path 30472"
								d="M345.287,361.63h-1.807V361h4.334v.634H346v5.08h-.71Z"
								transform="translate(-148.33 -242.066)"
								fill="#737376"
							/>
							<path
								id="Path_30473"
								data-name="Path 30473"
								d="M350.529,365.743a2.051,2.051,0,1,1,2.047,2.176,2.03,2.03,0,0,1-2.047-2.176m3.418,0a1.391,1.391,0,1,0-1.371,1.6,1.438,1.438,0,0,0,1.371-1.6"
								transform="translate(-151.374 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30474"
								data-name="Path 30474"
								d="M365.043,363.576a1.77,1.77,0,0,1,1.516.72l-.428.394a1.226,1.226,0,0,0-1.053-.54,1.607,1.607,0,0,0,0,3.2,1.247,1.247,0,0,0,1.053-.54l.428.394a1.771,1.771,0,0,1-1.516.719,2.174,2.174,0,0,1,0-4.342"
								transform="translate(-156.749 -243.173)"
								fill="#737376"
							/>
							<rect
								id="Rectangle_15107"
								data-name="Rectangle 15107"
								width="0.642"
								height="5.714"
								transform="translate(210.696 118.93)"
								fill="#737376"
							/>
							<path
								id="Path_30475"
								data-name="Path 30475"
								d="M373.779,365.743a2.051,2.051,0,1,1,2.047,2.176,2.03,2.03,0,0,1-2.047-2.176m3.417,0a1.391,1.391,0,1,0-1.37,1.6,1.438,1.438,0,0,0,1.37-1.6"
								transform="translate(-161.414 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30476"
								data-name="Path 30476"
								d="M382.482,366.805a1.875,1.875,0,0,0,1.362.59c.634,0,.977-.282.977-.685,0-.454-.505-.6-1.062-.737-.7-.163-1.5-.351-1.5-1.208,0-.642.557-1.191,1.542-1.191a2.094,2.094,0,0,1,1.533.6l-.3.445a1.61,1.61,0,0,0-1.233-.523c-.565,0-.917.257-.917.625,0,.4.471.532,1.011.66.72.163,1.55.368,1.55,1.285,0,.694-.556,1.25-1.627,1.25a2.2,2.2,0,0,1-1.67-.65Z"
								transform="translate(-165.026 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30477"
								data-name="Path 30477"
								d="M391.372,363.576a2.009,2.009,0,0,1,1.987,2.219v.163H390.01a1.458,1.458,0,0,0,1.49,1.431,1.81,1.81,0,0,0,1.276-.523l.308.42a2.249,2.249,0,0,1-1.645.634,2.174,2.174,0,0,1-.069-4.343m-1.362,1.91h2.715a1.341,1.341,0,0,0-1.362-1.379,1.381,1.381,0,0,0-1.353,1.379"
								transform="translate(-168.131 -243.173)"
								fill="#737376"
							/>
							<path
								id="Path_30478"
								data-name="Path 30478"
								d="M320.131,366.849H306.425A3.426,3.426,0,0,1,303,363.422v-7.995A3.426,3.426,0,0,1,306.425,352h13.706a3.426,3.426,0,0,1,3.426,3.426v7.995a3.426,3.426,0,0,1-3.426,3.426"
								transform="translate(-130.887 -238.209)"
								fill="#fff"
							/>
							<path
								id="Path_30479"
								data-name="Path 30479"
								d="M320.131,366.849H306.425A3.43,3.43,0,0,1,303,363.422v-7.995A3.43,3.43,0,0,1,306.425,352h13.706a3.43,3.43,0,0,1,3.426,3.426v7.995a3.43,3.43,0,0,1-3.426,3.426m-13.706-14.277a2.859,2.859,0,0,0-2.855,2.855v7.995a2.859,2.859,0,0,0,2.855,2.855h13.706a2.859,2.859,0,0,0,2.855-2.855v-7.995a2.859,2.859,0,0,0-2.855-2.855Z"
								transform="translate(-130.887 -238.209)"
								fill="#e8e8e8"
							/>
							<path
								id="Path_30480"
								data-name="Path 30480"
								d="M309.923,360.94h3.743v.634h-3.032v1.842h2.972v.634h-2.972v1.97h3.032v.634h-3.743Z"
								transform="translate(-133.837 -242.041)"
								fill="#737376"
							/>
							<path
								id="Path_30481"
								data-name="Path 30481"
								d="M318.117,366.75a1.874,1.874,0,0,0,1.362.59c.634,0,.977-.282.977-.685,0-.454-.505-.6-1.062-.737-.7-.163-1.5-.351-1.5-1.208,0-.642.557-1.191,1.542-1.191a2.094,2.094,0,0,1,1.533.6l-.3.445a1.61,1.61,0,0,0-1.233-.523c-.565,0-.917.257-.917.625,0,.4.471.532,1.011.66.72.163,1.55.368,1.55,1.285,0,.694-.556,1.25-1.627,1.25a2.2,2.2,0,0,1-1.67-.65Z"
								transform="translate(-137.231 -243.15)"
								fill="#737376"
							/>
							<path
								id="Path_30482"
								data-name="Path 30482"
								d="M327.032,363.52a1.771,1.771,0,0,1,1.516.72l-.428.394a1.227,1.227,0,0,0-1.054-.54,1.607,1.607,0,0,0,0,3.2,1.248,1.248,0,0,0,1.054-.54l.428.394a1.772,1.772,0,0,1-1.516.719,2.174,2.174,0,0,1,0-4.342"
								transform="translate(-140.334 -243.148)"
								fill="#737376"
							/>
							<path
								id="Path_30483"
								data-name="Path 30483"
								d="M29.073,32.021H25.337v-1.31H34.3v1.31H30.543v10.5H29.073Z"
								transform="translate(-10.868 -13.173)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30484"
								data-name="Path 30484"
								d="M41.736,47.253a1.23,1.23,0,0,0,1.275-.9l.567-1.292L40,36.416h1.434l2.851,7.012,2.833-7.012h1.452L44.286,46.7a2.543,2.543,0,0,1-2.514,1.735,4.319,4.319,0,0,1-.974-.124l.213-1.2a2.049,2.049,0,0,0,.726.142"
								transform="translate(-17.158 -15.619)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30485"
								data-name="Path 30485"
								d="M57.422,48.067V36.257H58.75v1.274a3.574,3.574,0,0,1,2.886-1.487c2.248,0,3.807,1.7,3.807,4.479,0,2.762-1.558,4.5-3.807,4.5a3.5,3.5,0,0,1-2.886-1.505v4.551ZM61.3,37.23a3.161,3.161,0,0,0-2.55,1.364v3.859a3.176,3.176,0,0,0,2.55,1.381c1.718,0,2.745-1.416,2.745-3.311S63.017,37.23,61.3,37.23"
								transform="translate(-24.63 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30486"
								data-name="Path 30486"
								d="M78.562,36.044c2.585,0,4.108,2.018,4.108,4.586v.336H75.747a3.013,3.013,0,0,0,3.081,2.957,3.738,3.738,0,0,0,2.638-1.08l.637.868a4.646,4.646,0,0,1-3.4,1.31,4.241,4.241,0,0,1-4.356-4.5,4.276,4.276,0,0,1,4.214-4.479m-2.815,3.948H81.36a2.772,2.772,0,0,0-2.816-2.851,2.853,2.853,0,0,0-2.8,2.851"
								transform="translate(-31.89 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30487"
								data-name="Path 30487"
								d="M105.655,43.836a3.7,3.7,0,0,1-2.833,1.186,2.847,2.847,0,0,1-2.992-2.833,2.8,2.8,0,0,1,2.992-2.815,3.577,3.577,0,0,1,2.833,1.168V39c0-1.151-.921-1.806-2.16-1.806a3.4,3.4,0,0,0-2.621,1.186l-.62-.921a4.474,4.474,0,0,1,3.417-1.416c1.806,0,3.311.814,3.311,2.886v5.879h-1.328Zm0-2.444A2.864,2.864,0,0,0,103.3,40.33a1.881,1.881,0,1,0,0,3.736A2.864,2.864,0,0,0,105.655,43Z"
								transform="translate(-42.82 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30488"
								data-name="Path 30488"
								d="M128.4,36.044a3.66,3.66,0,0,1,3.134,1.487l-.885.814a2.536,2.536,0,0,0-2.178-1.115,2.98,2.98,0,0,0-2.957,3.293c0,1.895,1.134,3.312,2.957,3.312a2.579,2.579,0,0,0,2.178-1.116l.885.814a3.659,3.659,0,0,1-3.134,1.488,4.23,4.23,0,0,1-4.267-4.5,4.224,4.224,0,0,1,4.267-4.479"
								transform="translate(-53.244 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30489"
								data-name="Path 30489"
								d="M139.478,40.523a4.238,4.238,0,1,1,8.463,0,4.239,4.239,0,1,1-8.463,0m7.065,0c0-1.735-1.01-3.293-2.833-3.293s-2.851,1.558-2.851,3.293c0,1.753,1.027,3.312,2.851,3.312s2.833-1.558,2.833-3.312"
								transform="translate(-60.237 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30490"
								data-name="Path 30490"
								d="M168.4,39c0-1.08-.478-1.771-1.576-1.771a2.993,2.993,0,0,0-2.267,1.31v6.269H163.23V39c0-1.08-.46-1.771-1.576-1.771a2.988,2.988,0,0,0-2.249,1.328v6.25h-1.328V36.256h1.328V37.5a3.7,3.7,0,0,1,2.762-1.452,2.2,2.2,0,0,1,2.3,1.593,3.6,3.6,0,0,1,2.868-1.593c1.558,0,2.391.868,2.391,2.585v6.18H168.4Z"
								transform="translate(-68.274 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30491"
								data-name="Path 30491"
								d="M193.449,39c0-1.08-.478-1.771-1.576-1.771a2.993,2.993,0,0,0-2.267,1.31v6.269h-1.328V39c0-1.08-.46-1.771-1.576-1.771a2.988,2.988,0,0,0-2.249,1.328v6.25h-1.328V36.256h1.328V37.5a3.7,3.7,0,0,1,2.762-1.452,2.2,2.2,0,0,1,2.3,1.593,3.6,3.6,0,0,1,2.868-1.593c1.558,0,2.391.868,2.391,2.585v6.18h-1.328Z"
								transform="translate(-79.092 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30492"
								data-name="Path 30492"
								d="M213.162,43.836a3.7,3.7,0,0,1-2.833,1.186,2.847,2.847,0,0,1-2.992-2.833,2.8,2.8,0,0,1,2.992-2.815,3.577,3.577,0,0,1,2.833,1.168V39c0-1.151-.921-1.806-2.16-1.806a3.4,3.4,0,0,0-2.621,1.186l-.62-.921a4.474,4.474,0,0,1,3.417-1.416c1.806,0,3.311.814,3.311,2.886v5.879h-1.328Zm0-2.444a2.864,2.864,0,0,0-2.355-1.062,1.881,1.881,0,1,0,0,3.736A2.864,2.864,0,0,0,213.162,43Z"
								transform="translate(-89.542 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30493"
								data-name="Path 30493"
								d="M230.283,39.213c0-1.505-.762-1.983-1.913-1.983a3.3,3.3,0,0,0-2.532,1.328v6.25h-1.328V36.256h1.328V37.5a4.242,4.242,0,0,1,3.046-1.452,2.431,2.431,0,0,1,2.727,2.762v6h-1.328Z"
								transform="translate(-96.958 -15.461)"
								fill="#b9b9ba"
							/>
							<path
								id="Path_30494"
								data-name="Path 30494"
								d="M247.416,41.246a3.6,3.6,0,0,1-2.886,1.488c-2.231,0-3.807-1.7-3.807-4.48,0-2.726,1.558-4.5,3.807-4.5a3.574,3.574,0,0,1,2.886,1.505V30.711h1.328v11.81h-1.328Zm0-4.922a3.21,3.21,0,0,0-2.568-1.381c-1.717,0-2.745,1.417-2.745,3.311s1.027,3.293,2.745,3.293a3.181,3.181,0,0,0,2.568-1.345Z"
								transform="translate(-103.962 -13.173)"
								fill="#b9b9ba"
							/>
						</g>
						<rect
							id="Rectangle_15369"
							data-name="Rectangle 15369"
							width="384.673"
							height="0.571"
							transform="translate(5.228 44.859)"
							fill="#eef0f4"
						/>
						<path
							id="Path_32807"
							data-name="Path 32807"
							d="M22.545,90H387.22c2.51,0,4.544,2.789,4.544,6.229v25.7c0,3.44-2.035,6.229-4.544,6.229H22.545c-2.51,0-4.544-2.789-4.544-6.229v-25.7C18,92.789,20.036,90,22.545,90"
							transform="translate(-7.721 -34.689)"
							fill="#f7fafe"
						/>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'CommandBarDispalySvg',
};
</script>
